import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CruiseActivityIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CruiseActivityIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M22.6983 18.8912L20.2445 16.4374C20.0645 16.2574 19.7978 16.1974 19.5644 16.2774L18.4842 16.6374L17.2707 15.4239C20.4179 12.0433 22.1515 7.66926 21.9181 3.60857C21.8981 3.26851 21.6314 3.0018 21.2913 2.9818C17.224 2.74843 12.8566 4.48205 9.47601 7.62925L8.26247 6.41571L8.62253 5.33553C8.70254 5.09549 8.64253 4.82878 8.4625 4.65542L6.00875 2.20167C5.88206 2.07498 5.71537 2.0083 5.53534 2.0083C5.35531 2.0083 5.18861 2.08165 5.06193 2.20167L3.09493 4.16867C2.83489 4.42871 2.83489 4.84878 3.09493 5.10883L5.54868 7.56258C5.67537 7.68927 5.84873 7.75595 6.02209 7.75595C6.09544 7.75595 6.16211 7.74261 6.23546 7.72261L7.31564 7.36255L8.52918 8.57609C5.38198 11.9567 3.64836 16.3307 3.88173 20.3914C3.90173 20.7315 4.16845 20.9982 4.5085 21.0182C4.74854 21.0315 4.99525 21.0382 5.23529 21.0382C9.08927 21.0382 13.1433 19.3312 16.3238 16.3707L17.5374 17.5843L17.1773 18.6644C17.0973 18.9045 17.1573 19.1712 17.3373 19.3446L19.7911 21.7983C19.9178 21.925 20.0845 21.9917 20.2645 21.9917C20.4445 21.9917 20.6112 21.9183 20.7379 21.7983L22.7049 19.8313C22.965 19.5713 22.965 19.1512 22.7049 18.8912H22.6983ZM20.5512 4.28869H20.5979C20.6112 7.80929 19.0443 11.5366 16.3238 14.4771L15.3103 13.4636L15.7237 13.0502C16.2438 12.5301 16.5305 11.8366 16.5305 11.1032C16.5305 10.3697 16.2438 9.67627 15.7237 9.15618C14.6502 8.08267 12.9033 8.08267 11.8364 9.15618L11.423 9.56958L10.4095 8.55608C13.3367 5.84229 17.044 4.28202 20.5512 4.28202V4.28869ZM11.0096 11.8766L11.423 11.4632L13.43 13.4703L13.0166 13.8837C12.4632 14.4371 11.563 14.4371 11.0096 13.8837C10.7429 13.6169 10.5962 13.2569 10.5962 12.8835C10.5962 12.5101 10.7429 12.15 11.0096 11.8833V11.8766ZM12.3632 10.5231L12.7766 10.1097C13.05 9.8363 13.4167 9.69628 13.7767 9.69628C14.1368 9.69628 14.5035 9.8363 14.7769 10.1097C15.0436 10.3764 15.1903 10.7365 15.1903 11.1099C15.1903 11.4833 15.0436 11.8433 14.7769 12.11L14.3635 12.5234L12.3565 10.5164L12.3632 10.5231ZM6.18879 6.3157L4.49517 4.62208L5.51534 3.60191L7.20896 5.29553L6.95558 6.06233L6.18879 6.3157ZM5.22863 19.698H5.18196C5.16862 16.1774 6.73556 12.4501 9.45602 9.50957L10.4695 10.5231L10.0561 10.9365C9.53603 11.4566 9.24932 12.15 9.24932 12.8835C9.24932 13.6169 9.53604 14.3104 10.0561 14.8305C10.5895 15.3639 11.2963 15.6373 12.0031 15.6373C12.7099 15.6373 13.41 15.3706 13.9501 14.8305L14.3635 14.4171L15.377 15.4306C12.4499 18.1444 8.74257 19.7046 5.23531 19.7046L5.22863 19.698ZM20.2578 20.3847L18.5642 18.6911L18.8176 17.9243L19.5844 17.6709L21.278 19.3646L20.2578 20.3847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CruiseActivityIcon;
